module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-mobile@2x-3ade23ef83c67641ae80a06fbe978e96.jpg";